// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__Fn5By","info":"Note_info__WF9Ov","note":"Note_note__2NzH7","actions":"Note_actions__3yCUz"};